import { render, staticRenderFns } from "./UserMessage.vue?vue&type=template&id=6126d77a&scoped=true&"
import script from "./UserMessage.vue?vue&type=script&lang=js&"
export * from "./UserMessage.vue?vue&type=script&lang=js&"
import style0 from "./UserMessage.vue?vue&type=style&index=0&id=6126d77a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6126d77a",
  null
  
)

export default component.exports